import { render, staticRenderFns } from "./relationdetail.vue?vue&type=template&id=b77e204c&scoped=true"
import script from "./relationdetail.vue?vue&type=script&lang=js"
export * from "./relationdetail.vue?vue&type=script&lang=js"
import style0 from "./relationdetail.vue?vue&type=style&index=0&id=b77e204c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77e204c",
  null
  
)

export default component.exports